import { cx } from "class-variance-authority";
import type React from "react";
import { ReactComponent as Svg } from "./assets/arrow-down-1.svg";
import * as styles from "./Icon.module.scss";

type ChevronLeftProps = React.SVGProps<SVGSVGElement>;

export const ChevronLeft = ({ className, ...props }: ChevronLeftProps) => (
  <Svg className={cx(className ?? styles.base, styles.arrowLeft)} {...props} />
);
